// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3rWTz","label":"Radio_label__3KG0A","checkMark":"Radio_checkMark__3WwL5","disabled":"Radio_disabled__1Yaid"};